import { gql } from '@apollo/client';

const ADD_FUNDING_ACCOUNT = gql`
  mutation AddFundingAccount(
    $customerId: String
    $accountNumber: String!
    $routingNumber: String!
    $customizedName: String
    $status: FundingAccountStatus
    $channel: FundingAccountChannel
  ) {
    addFundingAccount(
      customerId: $customerId
      accountNumber: $accountNumber
      routingNumber: $routingNumber
      customizedName: $customizedName
      status: $status
      channel: $channel
    ) {
      id
      bankName
      isDefault
      numberLast4
      routingNumber
      status
      createdDate
    }
  }
`;

const EDIT_FUNDING_ACCOUNT = gql`
  mutation EditFundingAccount(
    $customerId: String
    $fundingAccountId: String!
    $status: FundingAccountStatus
    $customizedName: String
    $channel: FundingAccountChannel
  ) {
    patchFundingAccount(
      customerId: $customerId
      fundingAccountId: $fundingAccountId
      status: $status
      customizedName: $customizedName
      channel: $channel
    ) {
      id
      bankName
      isDefault
      numberLast4
      routingNumber
      status
      createdDate
    }
  }
`;

const EDIT_FUNDING_ACCOUNTS = gql`
  mutation EditFundingAccounts(
    $customerId: String!
    $fundingAccountIds: [String!]!
    $fundingAccountStatus: FundingAccountStatus!
  ) {
    editFundingAccounts(
      customerId: $customerId
      fundingAccountIds: $fundingAccountIds
      fundingAccountStatus: $fundingAccountStatus
    ) {
      status
      results {
        fundingAccountId
        success
        error
        fundingAccount {
          id
          bankName
          isDefault
          numberLast4
          routingNumber
          status
          createdDate
        }
      }
    }
  }
`;

export { ADD_FUNDING_ACCOUNT, EDIT_FUNDING_ACCOUNT, EDIT_FUNDING_ACCOUNTS };
